import React from 'react';
import email from '../../components/email.json';

export default function OptinInsideBox() {
  return (
    <main>
      <h4>{email.optin.landing.ui.body.section2.title.eng}</h4>
      <hr />
      <p>
        <strong>{email.optin.landing.ui.body.section2.firstTime.eng}</strong>
      </p>
      <p>
        <span>{email.optin.landing.ui.body.section2.assistance.eng}</span>
        <a href={'mailto:' + email.optin.landing.ui.body.section2.assistance.email.eng}>
          <span aria-hidden="true">{email.optin.landing.ui.body.section2.assistance.email.eng}</span>
        </a>
        <span>{email.optin.landing.ui.body.section2.assistance.splittingText.eng}</span>
        <span>{email.optin.landing.ui.body.section2.assistance.phone.eng}</span>
      </p>
      <p>
        <span>{email.optin.landing.ui.body.section2.thankYou.eng}</span>
      </p>
    </main>
  );
}
